import { ControllerService } from '../shared/service/controller.service';
import { PaymentService } from '../shared/service/payment.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import AdyenCheckout from '@adyen/adyen-web';
import { environment } from '../../environments/environment';
import { from } from 'rxjs/internal/observable/from';
import { catchError, concatMap } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { Donation } from '../shared/model/donation';

@Component({
  selector: 'app-step3-dropin',
  templateUrl: './step3-dropin.component.html',
  styleUrls: ['./step3-dropin.component.css'],
  providers: [PaymentService],
})
export class Step3DropinComponent implements OnInit {

  @ViewChild('hook', {static: true})
  hook: ElementRef;

  hasError = false;
  step = 'step3';
  model: Donation;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly controller: ControllerService,
    private readonly paymentService: PaymentService
  ) {
    this.hook = new ElementRef('');
    this.model = controller.getModel();
  }

  ngOnInit() {
    const navigationStep = this.model.getIncompleteNavigationStep(1);

    if (navigationStep != null) {
      this.router.navigate([navigationStep]);
    }

    this.paymentService.startAdyenSession(this.controller.getModel())
      .pipe(concatMap(sessionResponse => of(this.buildDropinConfiguration(sessionResponse))))
      .subscribe(configuration => {
        // Replace hook container with dropin component
        from(AdyenCheckout(configuration)).subscribe(checkout => {
          checkout.create('dropin').mount(this.hook.nativeElement);
        }, catchError(err => {
          this.showError(err);
          throw err;
        }))
      });
  }

  private handlePaymentComplete(state: any, component: any) {
    if (state.action != null) {
      component.handleAction(state.action);
    } else {
      this.router.navigate(
        ['/result'],
        {
          queryParams: {
            stateResultCode: state.resultCode
          },
        }
      );
    }
  }

  private buildDropinConfiguration(sessionResponse) {
    const configuration = {
      clientKey: environment.ADYEN_CLIENT_KEY,
      locale: this.controller.locale,
      environment: environment.ADYEN_ENV,
      session: sessionResponse,
      paymentMethodsConfiguration: {
        ideal: {
          showImage: true
        },
        card: {
          hasHolderName: true,
          holderNameRequired: true,
          name: 'Credit or debit card',
        }
      },
      // Only called for payments without redirect, such as creditcards
      onPaymentCompleted: (state: any, component: any) => {
        this.handlePaymentComplete(state, component);
      },
      onError: (error: any, component: any) => {
        this.showError(error.name, error.message, error.stack, component);
      }
    };

    // Only needed for test. This will be automatically retrieved when you are in production.
    if (!environment.production) {
      configuration['countryCode'] = 'NL'
    }

    return configuration;
  }

  private showError(...errors: any) {
    console.error(errors);
    this.hasError = true;
  }

}
